module.exports = __webpack_public_path__ + "img/kefu.d65c89c9.png";